import React from 'react';
import TeamFilter from '../../../team-filter/containers/TeamFilter';

const Filter = () => (
  <TeamFilter
    link="/<%=season%>/<%=seasonSlug%>/<%=leagues%>/<%=leagueSlug%>/<%=teams%>/<%=teamSlug%>/scout-report" />
);

export default Filter;



// WEBPACK FOOTER //
// ./src/features/scout-report/components/Filter/Filter.js